'use client';

import { Button, InputField } from '@pickleballinc/react-ui';
import { RecaptchaNotice } from '@pickleballinc/ui/components/ui/recaptcha-notice';

import { PRIVACY_POLICY_URL } from '@/utils/helpers/constants';

interface NewsletterFooterSignUpProps {
  email: string;
  onEmailChange: (value: string) => void;
  handleSubscribe: () => void;
  displayError: string;
  isPending: boolean;
  isSuccess: boolean;
  btnSize: 'sm' | 'md';
}

export const NewsletterFooterSignUp = ({
  btnSize,
  email,
  onEmailChange,
  handleSubscribe,
  displayError,
  isPending,
  isSuccess,
}: NewsletterFooterSignUpProps) => {
  return (
    <div className='flex flex-col w-full mx-auto max-w-[1280px] pb-4 lg:py-4 xl:px-0 sm:px-8'>
      <div className='flex flex-col gap-6 w-full items-start'>
        <div className='flex flex-col gap-4 w-full lg:w-[768px]'>
          <h2 className='text-white font-semibold text-base sm:text-4xl sm:leading-[44px]'>
            Get the Latest Pickleball News
          </h2>
          <p className='text-white text-xs sm:text-xl leading-[18px] lg:leading-[30px]'>
            Be in the know - 200k+ subscribers. <br className='sm:hidden block' /> 5 minute emails.
            <br className='hidden sm:block' /> 1 weekly update.
          </p>
        </div>
        <div className='flex flex-col w-full gap-4 sm:gap-1.5'>
          <div className='flex flex-col max-w-[480px] sm:flex-row w-full gap-4'>
            <div className='w-full'>
              <InputField
                className='!rounded-lg !px-1.5 py-0 sm:!py-0.5'
                value={email}
                type='email'
                hasError={!!displayError}
                placeholder='Enter your email'
                onChange={(e) => {
                  onEmailChange(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSubscribe();
                  }
                }}
                disabled={isPending}
              />
            </div>
            <Button
              size={btnSize}
              className='!w-full sm:!w-auto !justify-center'
              variant='primary'
              onClick={handleSubscribe}
              disabled={isPending}
            >
              {isPending ? 'Subscribing...' : 'Subscribe'}
            </Button>
          </div>
          <span className='text-gray-400 text-xs sm:text-sm leading-[18px] sm:leading-5'>
            {`We care about your data in our `}
            <a
              href={PRIVACY_POLICY_URL}
              target='_blank'
              rel='noopener noreferrer'
              className='underline'
              aria-label={`Link to ${PRIVACY_POLICY_URL} (opens in a new tab)`}
            >
              privacy policy
            </a>
            .
          </span>
          <RecaptchaNotice className='text-gray-400 text-xs sm:text-sm leading-[18px] sm:leading-5' />
          <div className='min-h-6'>
            {displayError ? (
              <span className='text-error-400 sm:text-md text-sm'>{displayError}</span>
            ) : isSuccess ? (
              <span className='text-green-200 text-xs sm:text-sm'>{`You're subscribed!`}</span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
